import { SHOW_REVIEWS } from "@/config/features";

const advantages = [
  {
    icon: "ri-award-fill",
    title: "Certifié COFRAC",
    desc: "Tous nos diagnostiqueurs sont certifiés par des organismes accrédités COFRAC. Vos rapports sont reconnus par tous les notaires et agences.",
  },
  {
    icon: "ri-timer-flash-fill",
    title: "RDV sous 48h",
    desc: "Nous intervenons dans toute l'Île-de-France sous 48h. Urgence ? Contactez-nous pour un rendez-vous le jour même.",
  },
  {
    icon: "ri-file-text-fill",
    title: "Rapport le jour même",
    desc: "Votre rapport certifié vous est envoyé par email le jour de l'intervention. Idéal pour respecter vos délais de vente ou location.",
  },
  {
    icon: "ri-price-tag-3-fill",
    title: "Tarifs transparents",
    desc: "Pas de mauvaise surprise : nos tarifs sont affichés dès le devis. Dès 130 € TTC pour un DPE, sans frais cachés.",
  },
];

export default function WhyUs() {
  return (
    <section className="bg-gradient-to-br from-[#0F3B5F] to-[#0a2d4a] py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Left */}
          <div className="lg:col-span-2">
            <span className="inline-block bg-white/10 text-white text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-5">
              Pourquoi nous choisir
            </span>
            <h2 className="text-4xl font-extrabold text-white mb-5 leading-tight" style={{ fontFamily: "Barlow, sans-serif" }}>
              L'expert de confiance pour vos diagnostics en IDF
            </h2>
            <p className="text-white/75 text-base leading-relaxed mb-8">
              Depuis 10 ans, Up Diag accompagne les propriétaires, bailleurs et agences immobilières de Paris et d'Île-de-France avec des diagnostics fiables, rapides et certifiés.
            </p>
            {/* Stats */}
            <div className="flex flex-col gap-5">
              {[
                { value: "+2 500", label: "diagnostics réalisés", icon: "ri-bar-chart-fill" },
                ...(SHOW_REVIEWS
                  ? [{ value: "4.9/5", label: "note Google (127 avis)", icon: "ri-star-fill" }]
                  : [{ value: "48h", label: "délai d'intervention garanti", icon: "ri-timer-flash-fill" }]),
                { value: "100%", label: "rapports livrés le jour même", icon: "ri-checkbox-circle-fill" },
              ].map((stat) => (
                <div key={stat.label} className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-xl flex-shrink-0">
                    <i className={`${stat.icon} text-[#F97316] text-xl`}></i>
                  </div>
                  <div>
                    <div className="text-2xl font-extrabold text-white" style={{ fontFamily: "Barlow, sans-serif" }}>{stat.value}</div>
                    <div className="text-sm text-white/60">{stat.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right */}
          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {advantages.map((adv) => (
              <div
                key={adv.title}
                className="bg-white/8 backdrop-blur-sm border border-white/15 rounded-2xl p-6 hover:bg-white/12 transition-all duration-300 group"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#F97316]/20 rounded-xl mb-4 group-hover:bg-[#F97316]/30 transition-colors">
                  <i className={`${adv.icon} text-[#F97316] text-2xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-white mb-2" style={{ fontFamily: "Barlow, sans-serif" }}>{adv.title}</h3>
                <p className="text-sm text-white/70 leading-relaxed">{adv.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
